<!--Desktop Banner-->
<fgb-desktop-nav-banner [pageName]="'wallet.page.title' | translate" [imageName]="'rewards'"></fgb-desktop-nav-banner>

<div class="d-none d-lg-block">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<!--Mobile Navigation-->
<fgb-mobile-nav-menu
  [pageName]="'wallet.page.title' | translate"
  [showHamburger]="false"
  [showWalletButton]="false"
></fgb-mobile-nav-menu>

<!--Barcode (draggable on mobile)-->
<div
  #barcodeWrapper
  class="barcode-collapse-wrapper d-lg-none"
  [class.collapsed]="!isDragging && isBarcodeCollapsed"
  [class.no-transition]="isDragging"
  [style.max-height.px]="isDragging ? dragBarcodeHeight : null"
>
  <fgb-barcode></fgb-barcode>
</div>

<div class="bg-primary d-lg-none mobile-header-background"></div>
<div class="mobile-page-content">
  <!--Drag Handle-->
  <div
    class="drag-handle d-lg-none"
    (touchstart)="onHandleTouchStart($event)"
    (touchmove)="onHandleTouchMove($event)"
    (touchend)="onHandleTouchEnd()"
  >
    <div class="drag-handle-pill"></div>
  </div>

  <!--Wallet-->
  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="wallet-redeem-carousel pt-lg-4 pt-2">
      <div class="container">
        <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>

  <div class="container claimed-padding text-center mb-5">
    <div class="claimed-button bg-white">
      <div class="claimed-button-text">
        <h5 class="mb-1 fw-bold">{{ 'wallet.redemption.history.title' | translate }}</h5>
        <div class="font-size-14">{{ 'wallet.redemption.history.description' | translate }}</div>
      </div>
      <a
        class="font-size-14 claimed-text fw-bold btn btn-white rounded border-black text-black wallet-claimed-button"
        [routerLink]="['/rewards/claimed']"
      >
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
